<template>
  <a-modal
    :width="800"
    :visible="visible"
    :title="'分享链接管理 - ' + (model.name || '')"
    :confirmLoading="loading"
    @cancel="handleCancel"
    :footer="null"
  >
    <div class="share-link-container">
      <!-- 添加新链接 -->
      <div class="add-section">
        <a-button type="primary" icon="plus" @click="handleAddLink">添加分享链接</a-button>
      </div>

      <!-- 链接列表 -->
      <a-table
        :columns="columns"
        :dataSource="linkList"
        :loading="tableLoading"
        :pagination="false"
        rowKey="id"
        size="small"
      >
        <span slot="image" slot-scope="text">
          <img v-if="text" :src="text" style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px;" />
          <span v-else style="color: #999;">无图片</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEditLink(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDeleteLink(record)"
          >
            <a style="color: red;">删除</a>
          </a-popconfirm>
        </span>
      </a-table>

      <!-- 编辑/添加弹窗 -->
      <a-modal
        :width="500"
        :visible="editVisible"
        :title="editModel.id ? '编辑分享链接' : '添加分享链接'"
        :confirmLoading="editLoading"
        @ok="handleEditOk"
        @cancel="handleEditCancel"
      >
        <a-form :form="editForm">
          <a-form-item label="标题" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
            <a-input
              v-decorator="['title', { rules: [{ required: true, message: '请输入标题' }] }]"
              placeholder="请输入标题"
            />
          </a-form-item>
          <a-form-item label="AppID" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
            <a-input
              v-decorator="['app_id', { rules: [{ required: true, message: '请输入AppID' }] }]"
              placeholder="例如: wx1234567890abcdef"
            />
          </a-form-item>
          <a-form-item label="页面路径" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
            <a-input
              v-decorator="['page_path']"
              placeholder="例如: pages/index/index（可选）"
            />
          </a-form-item>
          <a-form-item label="图片" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
            <a-upload
              list-type="picture-card"
              :show-upload-list="false"
              :before-upload="beforeUpload"
              :customRequest="customRequest"
            >
              <img v-if="imageUrl" :src="imageUrl" style="width: 100px; height: 100px; object-fit: cover;" />
              <div v-else style="width: 100px; height: 100px; display: flex; align-items: center; justify-content: center;">
                <a-icon type="plus" />
                <div style="margin-top: 8px; font-size: 12px;">上传图片</div>
              </div>
            </a-upload>
          </a-form-item>
          <a-form-item label="排序" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">
            <a-input-number
              v-decorator="['sort_order', { initialValue: 0 }]"
              :min="0"
              placeholder="数字越大越靠前"
            />
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
  </a-modal>
</template>

<script>
import { share_link_list, share_link_create, share_link_update, share_link_delete } from '@/api/business_card'
import { oss_token_list } from '@/api/oss_token'
import axios from 'axios'

export default {
  name: 'ShareLinkForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      linkList: [],
      tableLoading: false,
      editVisible: false,
      editLoading: false,
      editForm: this.$form.createForm(this),
      editModel: {},
      imageUrl: '',
      ossParams: {}
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '标题',
          dataIndex: 'title',
          width: 120
        },
        {
          title: '图片',
          dataIndex: 'image',
          width: 80,
          scopedSlots: { customRender: 'image' }
        },
        {
          title: 'AppID',
          dataIndex: 'app_id',
          width: 150,
          ellipsis: true
        },
        {
          title: '页面路径',
          dataIndex: 'page_path',
          ellipsis: true
        },
        {
          title: '排序',
          dataIndex: 'sort_order',
          width: 80
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  watch: {
    visible (val) {
      if (val && this.model && this.model.user_id) {
        this.loadLinkList()
        this.initOss()
      }
    }
  },
  mounted () {
    if (this.visible && this.model && this.model.user_id) {
      this.loadLinkList()
      this.initOss()
    }
  },
  methods: {
    async initOss () {
      const { data } = await oss_token_list()
      this.ossParams = {
        OSSAccessKeyId: data.accessid,
        policy: data.policy,
        signature: data.signature
      }
    },
    loadLinkList () {
      this.tableLoading = true
      share_link_list({ user_id: this.model.user_id }).then(res => {
        if (res.success) {
          this.linkList = res.data.entries || []
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    handleCancel () {
      this.$emit('cancel')
    },
    handleAddLink () {
      this.editModel = {}
      this.imageUrl = ''
      this.editVisible = true
      this.editForm.resetFields()
    },
    handleEditLink (record) {
      this.editModel = record
      this.imageUrl = record.image || ''
      this.editVisible = true
      this.$nextTick(() => {
        this.editForm.setFieldsValue({
          title: record.title,
          app_id: record.app_id,
          page_path: record.page_path,
          sort_order: record.sort_order
        })
      })
    },
    handleEditCancel () {
      this.editVisible = false
      this.editForm.resetFields()
      this.imageUrl = ''
    },
    handleEditOk () {
      this.editForm.validateFields((err, values) => {
        if (!err) {
          values.user_id = this.model.user_id
          values.image = this.imageUrl
          this.editLoading = true

          let promise
          if (this.editModel.id) {
            promise = share_link_update(values, this.editModel.id)
          } else {
            promise = share_link_create(values)
          }

          promise.then(res => {
            if (res.success) {
              this.$message.success('操作成功')
              this.editVisible = false
              this.editForm.resetFields()
              this.imageUrl = ''
              this.loadLinkList()
            }
          }).finally(() => {
            this.editLoading = false
          })
        }
      })
    },
    handleDeleteLink (record) {
      share_link_delete(record.id).then(res => {
        if (res.success) {
          this.$message.success('删除成功')
          this.loadLinkList()
        }
      })
    },
    beforeUpload (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB')
        return false
      }
      return true
    },
    customRequest (options) {
      const file = options.file
      const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      const key = `${file.uid}_${Date.now()}.${suffix}`

      const formData = new FormData()
      formData.append('key', key)
      formData.append('policy', this.ossParams.policy)
      formData.append('OSSAccessKeyId', this.ossParams.OSSAccessKeyId)
      formData.append('signature', this.ossParams.signature)
      formData.append('success_action_status', '200')
      formData.append('file', file)

      axios.post('https://static2.jnzbtz.com', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(() => {
        this.imageUrl = `https://static2.jnzbtz.com/${key}`
        this.$message.success('上传成功')
      }).catch(() => {
        this.$message.error('上传失败')
      })
    }
  }
}
</script>

<style scoped>
.share-link-container {
  padding: 10px 0;
}
.add-section {
  margin-bottom: 16px;
}
</style>
